module.exports = __webpack_public_path__ + "img/2_x8.4f826f07.png";